import { Autocomplete, Chip, TextField } from "@mui/material"
import { useEffect, useState } from "react"
import { toast } from "react-toastify"
import api from "../../services/api"

function AutoCompleteConnection({ selecteds = [], setSelecteds, disabled }) {
    const [whatsapps, setWhatsapps] = useState([])

    async function loadConnections() {
        try {
            const { data } = await api.get("/whatsapp")

            setWhatsapps(data)
        } catch (error) {
            toast.error("Erro ao buscar conexões")
        }
    }

    useEffect(() => {
        loadConnections()
    }, [])

    const onChange = async (value) => {
        let optionsChanged = []
        optionsChanged = value
        setSelecteds(optionsChanged)
    }

    return (
        <Autocomplete
            multiple
            options={whatsapps || []}
            value={selecteds || ""}
            freeSolo
            onChange={(e, value, reason) => onChange(value, reason)}
            getOptionLabel={(option) => (option.name ? option.name : "")}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            disabled={disabled}
            renderTags={(value, getTagProps) =>
                value.map((option, index) => (
                    <Chip
                        key={option.id}
                        variant="outlined"
                        style={{
                            backgroundColor: option.color || "#eee",
                            color: "white",
                            textShadow: "1px 1px 1px #000",
                        }}
                        label={option.name}
                        {...getTagProps({ index })}
                    />
                ))
            }
            renderInput={(params) => (
                <TextField
                    {...params}
                    variant="outlined"
                    placeholder="Conexões"
                />
            )}
        />
    )
}

export default AutoCompleteConnection
